import { useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from 'api/apiClient/apiClient'
import { Module } from 'types/modules'
import { useAuth } from 'ui/components/AuthContext/AuthContext'
import { useChannel, useEvent } from 'ui/components/PusherContext/PusherContext'

export const SYSTEM_MESSAGES_QUERY_KEY = `system-messages`

export type SystemMessage = {
  id: number
  title: string
  text: string
  severity: `info` | `warning` | `meetup`
  start_time: ISODateTime
  end_time: ISODateTime
  modules: Module[]
}

export function useSystemMessages() {
  const { systemId } = useAuth()
  const queryClient = useQueryClient()

  const { channel } = useChannel(`system-messages`)
  useEvent(channel, `new-system-message`, () => {
    queryClient.invalidateQueries({
      queryKey: [SYSTEM_MESSAGES_QUERY_KEY],
    })
  })

  return useQuery({
    queryKey: [SYSTEM_MESSAGES_QUERY_KEY],

    queryFn: () => apiClient<SystemMessage[]>(`system_messages`, { params: { system_id: systemId } }),

    enabled: !!systemId,
  })
}
